import { Breadcrumb } from "../../../../core/Breadcrumb.js";
import { Text } from "../../../../core/Text.js";
import { useChromeHints } from "../../../shared/chromeHints.js";
import type { ForgeBuilderHeadingContent } from "../../forgeContent.js";

/**
 * The builder's top: where it sits, its h1 and what to do. On phones the store's top bar shows
 * Back to the forge, and the tab bar steps aside while the summary's action bar is up.
 */
export function ForgeBuilderHeading({
  trail,
  current,
  title,
  intro,
  back,
  actionBar,
}: ForgeBuilderHeadingContent) {
  useChromeHints({ back, hideTabs: actionBar });
  return (
    <div className="flex flex-col gap-4 md:gap-5">
      <Breadcrumb items={[...trail, { label: current }]} className="max-md:hidden" />
      <div className="flex max-w-2xl flex-col gap-2">
        <Text as="h1" variant="display-xl2" tone="primary" className="max-md:text-display-xl3">
          {title}
        </Text>
        <Text variant="body-b1" tone="secondary">
          {intro}
        </Text>
      </div>
    </div>
  );
}
